import { StateUpdaterMethodTypes } from '@mm/utils';
import cryingMonkey from 'assets/monkey-crying.svg';
import React from 'react';
import { compose, withHandlers, withStateHandlers } from 'recompose';
import Button from '../../../buttons/DeprecatedButton/DeprecatedButton';
import Input from '../../../components/Input/Input';
import './CompleteDowngradingModal.scss';

const downgrades = [
  'Added Drip campaigns and Ads will stop working',
  'Contact exports and Connections will halt',
  'Bots that have Operator features enabled will stop functioning',
];

type OuterProps = {
  onBack: Function;
  completeDowngrade: Function;
};

type InitialState = ReturnType<typeof initialState>;
type StateUpdaters = StateUpdaterMethodTypes<
  InitialState,
  OuterProps,
  typeof stateUpdaters
>;

type PropsFromWithHandlers = {
  checkDowngradeConfirmation: ReturnType<typeof checkDowngradeConfirmation>;
};

type InnerProps = InitialState & StateUpdaters & PropsFromWithHandlers;

type Props = OuterProps & InnerProps;

const CompleteDowngradingModal = ({
  onBack,
  completeDowngrade,
  downgradeHelp,
  setDowngradeHelp,
  checks,
  checkDowngradeConfirmation,
}: Props) => {
  return (
    <div className="complete-downgrading__modal">
      <div className="complete-downgrading__modal">
        <div className="complete-downgrading__image-container">
          <img
            className="complete-downgrading__monkey-img"
            src={cryingMonkey}
          />
        </div>
        <div className="complete-downgrading__body">
          <div className="complete-downgrading__title">
            We're sorry to see you go…
          </div>
          <div className="complete-downgrading__sub-title">
            Do you mind providing a little bit more detail to help us understand
            why you're leaving?
          </div>
          <div className=" confirm-downgrade-modal__text complete-downgrading__text">
            <Input
              type="textarea"
              name="textarea-input"
              rows="3"
              value={downgradeHelp}
              onChange={e => setDowngradeHelp(e.target.value)}
            />
          </div>
          <div className="complete-downgrading__info">
            By clicking Complete Downgrade you are confirming:
          </div>
          <div className="complete-downgrading__checkbox">
            {downgrades.map((downgradeMessage, index) => (
              <>
                <label
                  className="complete-downgrading__choose-case"
                  key={index}
                >
                  <input
                    type="checkbox"
                    name="downgrade"
                    className="complete-downgrading__checkbox-button"
                    onChange={e =>
                      checkDowngradeConfirmation(
                        e.target.checked,
                        downgradeMessage,
                      )
                    }
                  />
                  {downgradeMessage}
                </label>
              </>
            ))}
          </div>
          <div className="complete-downgrading__buttons">
            <Button
              className="complete-downgrading__yes-button"
              superDarkGray
              onClick={onBack}
            >
              Go back
            </Button>
            <Button
              className="complete-downgrading__no-button"
              lightGrayLink
              disabled={
                !downgradeHelp.trim() ||
                !downgrades.every(d => checks.includes(d))
              }
              onClick={() => completeDowngrade(downgradeHelp)}
            >
              Complete cancellation
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

const checkDowngradeConfirmation =
  ({ checks, setChecks }) =>
  (checked, value) => {
    const newChecks = [...checks];
    checked
      ? newChecks.splice(0, 0, value)
      : newChecks.splice(newChecks.indexOf(value), 1);
    setChecks(newChecks);
  };

const initialState = (props: OuterProps) => {
  return {
    checks: [] as string[],
    downgradeHelp: '',
  };
};

const stateUpdaters = {
  setChecks: () => checks => ({ checks }),
  setDowngradeHelp: () => downgradeHelp => ({ downgradeHelp }),
};

const enhance = compose<InnerProps, OuterProps>(
  withStateHandlers(initialState, stateUpdaters),
  withHandlers({ checkDowngradeConfirmation }),
);

export default enhance(CompleteDowngradingModal);
